import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { InlineInputGroup } from 'barnyard/components';
import SupplierSelect from '~/app/corporate/core/containers/SupplierSelect';


const InlineSupplierSelect = (props) => {
  const {
    label,
    description,
    ...other
  } = props;

  return (
    <InlineInputGroup
      label={label}
      description={description}
      InputComponent={SupplierSelect}
      include_all={true}
      include_any={true}
      required={false}
      {...other}
    />
  );
};

InlineSupplierSelect.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
};

InlineSupplierSelect.defaultProps = {
  label: 'Suppliers',
  description: 'Suppliers to be included'
};

export default memo(InlineSupplierSelect);
